import { render, staticRenderFns } from "./campaignsBarChart.vue?vue&type=template&id=6935b272&scoped=true&"
import script from "./campaignsBarChart.vue?vue&type=script&lang=js&"
export * from "./campaignsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6935b272",
  null
  
)

export default component.exports